import React from 'react';
import { useParams } from 'react-router-dom';
import LocationDetailPage from '../../features/locationDetail/LocationDetailPage';

const LocationDetailRoute = () => {
  // You can use the id param to fetch real data in the future
  const { id } = useParams();
  // Pass id as prop if needed
  return <LocationDetailPage />;
};

export default LocationDetailRoute;
